import React, { useEffect, useState } from "react";
import CompanyLeftHOC from "../CompanyLeftHOC";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import useRequireAuth from "../../utils/useRequireAuth";
import { removeUser } from "../../utils/userSlice";
import { ReactComponent as LeftMenuIcon } from "../../assets/images/icons/Dashb.svg";
import { ReactComponent as LeftuserIcon } from "../../assets/images/icons/User_ManagementD.svg";
import { ReactComponent as Categorization } from "../../assets/images/icons/ct.svg";
import { ReactComponent as COA } from "../../assets/images/icons/Upload_COA.svg";
import { ReactComponent as LeftManageIcon } from "../../assets/images/icons/LeftManage.svg";
import { ReactComponent as LeftManageListIcon } from "../../assets/images/icons/LeftManageList.svg";
import { ReactComponent as LeftLogoutIcon } from "../../assets/images/icons/LeftLogout.svg";
import CompanyDashboard from "./CompanyDashboard";
import { useSidebar } from "../SidebarContext";
import { getOrganizationName } from "../../utils/utilityFunctions/localServices";
import Header from "../Header2";

function AddCompany() {
  const [activeLink, setActiveLink] = useState(null);
  const [editCompany, setEditCompany] = useState([]);
  const [editButtonState, setEditButtonState] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const user = useRequireAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignOut = async () => {
    const Authtoken = user.token;
    try {
      dispatch(removeUser(null));
      navigate("/dashboard");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  const sidebarLinks = [
    { title: "Dashboard", path: "/dashboardMain", icon: <LeftMenuIcon />, onClick: null },
    { title: "User Management", path: "/user", icon: <LeftuserIcon />, onClick: null, checkPermission: true },
    // {
    //   title: "Manage Permissions",
    //   path: "/manage_permission",
    //   icon: <LeftManageIcon />,
    //   onClick: null,
    //   checkPermission: true,
    // },
    { title: "Manage List", path: "/managelist", icon: <LeftManageListIcon />, onClick: null, checkPermission: true },
    {
      title: "Categorization",
      path: null,
      onClick: () => {
        const Authtoken = user.token;
        const url = `https://vgen.aizooks.com/index.html?accessin=${Authtoken}`;
        window.open(url, "_blank"); // opens in a new tab
      },
      icon: <Categorization />,
    },

    {
      title: "Upload Chart of Accounts",
      path: null,
      onClick: () => {
        const Authtoken = user.token;
        const url = `https://vgen.aizooks.com/upload-coa-data.html?accessin=${Authtoken}`;
        window.open(url, "_blank"); // opens in a new tab
      },
      icon: <COA />,
    },
    { title: "Logout", path: null, icon: <LeftLogoutIcon />, onClick: handleSignOut },
  ];

  const handleMenuClick = (index) => {
    setActiveLink(index); // Set active link on menu click
  };
  const getUserAccess = (value) => {
    const accessFlag = user?.permissions?.find(
      (ob) => ob?.sub_module?.toLowerCase() === value?.toLowerCase()
    )?.permission;
    return accessFlag === 1;
  };
  // on-top function and states for left icons menu bar  ------------------------------------------------------------

  return (
    <>
      <div className="flex w-full flex-col ">
        <Header />
        <div className="flex flex-row w-full mt-4 grow min-h-0">
          {/* left icons menu bar */}
          <div className="bg-white shadow-md rounded-md w-16 h-[calc(100vh-363px)] mx-3 border-[1px] border-[#D2DAE1] overflow-y-auto scrollbar-hidden">
            <ul className="text-gray-600 rounded-md flex items-center justify-center flex-col ">
              {sidebarLinks
                .filter((eachSidebar) => getUserAccess(eachSidebar.title) || !eachSidebar.checkPermission)
                .map((link, index) =>
                  link.path ? (
                    <li key={index} className="p-2 mt-4 hover:bg-[#F0F0F0] rounded-lg">
                      <NavLink exact="true" to={link.path} onClick={() => handleMenuClick(index)}>
                        {link.icon}
                      </NavLink>
                    </li>
                  ) : (
                    <li
                      key={index}
                      onClick={() => {
                        handleMenuClick(index);
                        if (link.onClick) link.onClick();
                      }}
                      className="p-2 mt-4 hover:bg-[#F0F0F0] cursor-pointer rounded-lg"
                    >
                      <span>{link.icon}</span>
                    </li>
                  )
                )}
            </ul>
          </div>

          {/* company component */}
          <CompanyDashboard
            EditCompanyData={editCompany}
            setEditCompany={setEditCompany}
            editButtonState={editButtonState}
            setEditButtonState={setEditButtonState}
          />
        </div>
      </div>
    </>
  );
}

// export default CompanyLeftHOC(AddCompany);
export default AddCompany;
